






































import Vue from "vue";
import ModalAddField from "@/components/campaign/ModalAddField.vue";
import { PropOptions } from "vue";
import { Campaign } from "@/models";

export default Vue.extend({
  components: { ModalAddField },
  props: {
    campaign: Object as PropOptions<Campaign>,
  },
  data() {
    return {
      modalVisible: false,
      hover: false,
    };
  },
  methods: {
    onFinish(result: string | null, type: string | null) {
      if (result) {
        this.$emit("update", result, type);
      }
      this.modalVisible = false;
    },
  },
});
